<ng-container *transloco="let global;" >
<ng-container *transloco="let t; read: 'assignment'" >
    <h2 class="mbm">{{t('service.title')}}</h2>
<kendo-grid
  [data]="services"
  (edit)="editHandler($event)"
  (cancel)="cancelHandler($event)"
  (save)="saveHandler($event)"
  (remove)="removeHandler($event)"
  (add)="addHandler($event)"
  scrollable="none"
  [skip]="gridState.skip"
  [pageSize]="gridState.pageSize"
  [pageable]="true"
  (pageChange)="onPageChange($event)"
>
  <ng-template kendoGridToolbarTemplate>
    <button kendoGridAddCommand>{{t('add')}}</button>
  </ng-template>

  <kendo-grid-column field="name" [title]="t('name')">
    <ng-template 
      kendoGridEditTemplate
      let-dataItem="dataItem"
      let-formGroup="formGroup"
    >
      <kendo-formfield>
        <kendo-textbox
          [formControl]="formGroup.get('name')"
        ></kendo-textbox>
        <kendo-formerror 
          *ngIf="formGroup.get('name').hasError('required')"
          >{{t('isRequiredField')}}</kendo-formerror>
        <kendo-formerror 
          *ngIf="formGroup.get('name').hasError('isNotUnique')"
        >{{t('nameMustBeUnique')}}</kendo-formerror>
      </kendo-formfield>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column field="defaultTime" [title]="t('time')" [width]="100">
    <ng-template kendoGridCellTemplate let-dataItem>
        <input
          kendoTextBox
          [readonly]="true"
          [value]="dataItem.defaultTimeObj | timeSpanToString"
        />
      </ng-template>
      <ng-template
        kendoGridEditTemplate
        let-dataItem="dataItem"
        let-formGroup="formGroup"
      >
        <input
          kendoTextBox
          [formControl]="formGroup.get('defaultTime')"
          placeholder="00:00"
        />
        <kendo-formerror 
          *ngIf="formGroup.get('defaultTime')?.hasError('invalidTimeFormat') && formGroup.get('defaultTime')?.touched"
        >{{global('errors.wrongTimeFormat')}}</kendo-formerror>
      </ng-template>
  </kendo-grid-column>

  <kendo-grid-column field="timeEntryCategoryId" [title]="t('category')">
    <ng-template kendoGridCellTemplate let-dataItem>
        {{ dataItem.timeEntryCategory?.name ?? "-" }}
      </ng-template>
  
      <ng-template
        kendoGridEditTemplate
        let-dataItem="dataItem"
        let-formGroup="formGroup"
      >
      <kendo-formfield>
        <kendo-dropdownlist
          [data]="timeEntryCategories"
          [defaultItem]="noCategory"
          textField="name"
          valueField="id"
          [valuePrimitive]="true"
          [formControl]="formGroup.get('timeEntryCategoryId')"
        >
        </kendo-dropdownlist>
        <kendo-formerror 
          *ngIf="formGroup.get('timeEntryCategoryId').hasError('required')"
          >{{t('isRequiredField')}}</kendo-formerror>
      </kendo-formfield>
      </ng-template>
  </kendo-grid-column>

  <kendo-grid-command-column
    [title]="t('action')"
  >
    <ng-template kendoGridCellTemplate let-isNew="isNew">
      <button kendoGridEditCommand themeColor="primary">{{t('edit')}}</button>
      <button kendoGridRemoveCommand>{{t('delete')}}</button>
      <button kendoGridSaveCommand [disabled]="formGroup?.invalid">
        {{ isNew ? t('add') : t('save') }}
      </button>
      <button kendoGridCancelCommand>
        {{ isNew ? t('discard') : t('cancel') }}
      </button>
    </ng-template>
  </kendo-grid-command-column>

  <ng-template
    let-totalPages="totalPages"
    let-currentPage="currentPage"
    kendoPagerTemplate
  >
    <div class="flex flexDirRow">
      <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
      <kendo-pager-numeric-buttons
        [buttonCount]="5"
      ></kendo-pager-numeric-buttons>
      <kendo-pager-next-buttons></kendo-pager-next-buttons>
    </div>
    <div>
      <label for="pageBtnGroup" class="mrs">{{t('resultsPerPage')}}</label>
      <kendo-buttongroup [selection]="'single'" id="pageBtnGroup">
        <button
          (click)="onPageSizeChange(pageSizes.Small)"
          kendoButton
          [selected]="gridState.pageSize === pageSizes.Small"
          [toggleable]="true"
        >
          {{ pageSizes.Small }}
        </button>
        <button
          (click)="onPageSizeChange(pageSizes.Medium)"
          kendoButton
          [selected]="gridState.pageSize === pageSizes.Medium"
          [toggleable]="true"
        >
          {{ pageSizes.Medium }}
        </button>
        <button
          (click)="onPageSizeChange(pageSizes.Large)"
          kendoButton
          [selected]="gridState.pageSize === pageSizes.Large"
          [toggleable]="true"
        >
          {{ pageSizes.Large }}
        </button>
      </kendo-buttongroup>

      <button
        kendoButton
        [title]="t('refresh')"
        (click)="onGridReload()"
        icon="reload"
      ></button>
    </div>
  </ng-template>
  <ng-template kendoGridNoRecordsTemplate>
    <div class="text pl">{{t('noResults')}}</div>
  </ng-template>

</kendo-grid>

<app-delete-confirm-dialog
  [(opened)]="deletionDialogOpened"
  [message]="t('service.deletionMessage')"
  (confirmed)="deleteConfirmed()"
></app-delete-confirm-dialog>

</ng-container>
</ng-container>